module.exports = __webpack_public_path__ + "static/media/step3.9f2799db.png";